AFRAME.registerComponent('right-configure-popup', {
    schema: {
        chartType: { type: 'string', default: 'Mountain' },
        accessability: { type: 'boolean', default: false },
        showExtendedHours: { type: 'boolean', default: false },
        showEvents: { type: 'boolean', default: false },
    },

    init: function () {
        this.STORAGE_KEY = 'rightConfigurePopupSettings';
        this.EXPIRATION_TIME = typeof CACHE_EXPIRATION !== 'undefined' ? CACHE_EXPIRATION.PERSISTENT : 5256000;

        this.themeMode = 'Dark';
        const mainSettings = getCacheItem('mainSettings');
        if (mainSettings && mainSettings.themeMode) {
            this.themeMode = mainSettings.themeMode;
        }

        window.addEventListener('theme-changed', (e) => {
            if (e.detail && e.detail.themeMode) {
                this.themeMode = e.detail.themeMode;
                this.updateTheme();
            }
        });

        const stored = this._loadSettings();
        if (stored) {
            const toApply = {};
            Object.keys(this.schema).forEach((key) => {
                if (Object.prototype.hasOwnProperty.call(stored, key)) {
                    toApply[key] = stored[key];
                }
            });
            if (Object.keys(toApply).length) {
                this.el.setAttribute('right-configure-popup', toApply);
            }
        } else {
            this._saveSettings();
        }

        this.setupDataIntervalListener();

        this.el.addEventListener('componentchanged', (evt) => {
            if (evt.detail.name === 'visible') {
                if (this.el.getAttribute('visible')) {
                    this.onOpen();
                }
            }
        });
    },

    updateTheme: function () {
        if (this.el.getAttribute('visible')) {
            this.createBackground();
            this.createHeader();
            this.createSettingsList();
        }
    },

    _loadSettings: function () {
        try {
            const data = getCacheItem(this.STORAGE_KEY);
            console.log('Loaded right configure popup settings from cache:', data);
            return data;
        } catch (e) {
            console.warn('Failed to load right configure popup settings', e);
            return null;
        }
    },

    _saveSettings: function () {
        try {
            const payload = {};
            Object.keys(this.schema).forEach((key) => {
                payload[key] = this.data[key];
            });
            setCacheItem(this.STORAGE_KEY, payload, this.EXPIRATION_TIME);
            console.log('Saved right configure popup settings to cache with expiration:', this.EXPIRATION_TIME);
        } catch (e) {
            console.warn('Failed to save right configure popup settings', e);
        }
    },

    open: function () {
        this.onOpen();
        this.el.setAttribute("scale", "1.5 1.5 1");
    },

    onOpen: function () {
        this.currentDataInterval = this._resolveCurrentDataInterval();
        this.createBackground();
        this.createHeader();
        this.createSettingsList();
    },

    createBackground: function () {
        this.el.querySelectorAll('.popup-background').forEach(el => el.parentNode.removeChild(el));

        const isLight = this.themeMode === 'Light';
        const bgColor = isLight ? '#F5F5F5' : '#111';

        const bg = document.createElement("a-plane");
        bg.classList.add('popup-background');
        bg.setAttribute("width", "0.6");
        bg.setAttribute("height", "0.34");
        bg.setAttribute("opacity", "0");
        bg.setAttribute("data-raycastable", "");
        bg.setAttribute("position", "0 0.3 0");
        this.el.appendChild(bg);

        const roundedBg = document.createElement("a-rounded-plane");
        roundedBg.classList.add('popup-background');
        roundedBg.setAttribute("position", "-0.3 0.130 -0.01");
        roundedBg.setAttribute("opacity", "1");
        roundedBg.setAttribute("width", "0.6");
        roundedBg.setAttribute("height", "0.34");
        roundedBg.setAttribute("radius", "0.02");
        roundedBg.setAttribute("color", bgColor);
        roundedBg.setAttribute("scale", "1 1 1");
        this.el.appendChild(roundedBg);
    },

    createHeader: function () {
        let headerContainer = this.el.querySelector('#right-configure-header');
        if (!headerContainer) {
            headerContainer = document.createElement('a-entity');
            headerContainer.setAttribute('id', 'right-configure-header');
            this.el.appendChild(headerContainer);
        }
        headerContainer.innerHTML = '';

        const isLight = this.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        const title = document.createElement('a-troika-text');
        title.setAttribute('value', 'Chart options');
        title.setAttribute('font-size', 0.03);
        title.setAttribute('color', txtColor);
        title.setAttribute('anchor', 'center');
        title.setAttribute('position', `0 0.43 0.01`)
        headerContainer.appendChild(title);

        const cross = document.createElement('a-troika-text');
        cross.setAttribute('value', '×');
        cross.setAttribute('font-size', 0.04);
        cross.setAttribute('color', txtColor);
        cross.setAttribute('anchor', 'center');
        cross.setAttribute('position', `0.26 0.43 0.01`)
        headerContainer.appendChild(cross);

        const interactivePlane = document.createElement('a-plane');
        interactivePlane.setAttribute('id', 'close-right-configure-popup');
        interactivePlane.setAttribute('height', 0.04);
        interactivePlane.setAttribute('width', 0.04);
        interactivePlane.setAttribute('position', `0.26 0.43 0.01`);
        interactivePlane.setAttribute('opacity', '0');
        interactivePlane.setAttribute('data-raycastable', '');
        interactivePlane.addEventListener('click', () => {
            this.el.setAttribute('visible', false);

            setTimeout(() => {
                this.el.innerHTML = '';
            }, 50);
        })
        headerContainer.appendChild(interactivePlane);
    },

    createSettingsList: function () {
        const is1d = this._normalizeDataInterval(this.currentDataInterval) === '1d';
        const { chartType,showExtendedHours, showEvents } = this.data;

        const isLight = this.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        const itemBgColor = isLight ? '#1e1e1e' : '#fff';
        const itemBgOpacity = '0.02';
        const selectColor = isLight ? '#3636E3' : '#FFFFFF';
        const selectedTextColor = isLight ? '#FFFFFF' : '#14141C';

        const list = [
            { key: 'chartType', label: 'Chart format', value: chartType, type: 'select' },
            // { key: 'showExtendedHours', label: 'Show extended hours', isActive: showExtendedHours, type: 'toggle', disabled: !is1d },
            { key: 'showEvents', label: 'Show key events', isActive: showEvents, type: 'toggle' },
        ]

        const contentElement = this.el.querySelector('#right-configure-popup-content');
        if (!contentElement) {
            const content = document.createElement('a-entity');
            content.setAttribute('id', 'right-configure-popup-content');
            content.setAttribute('position', '0 0.4 0');
            this.el.appendChild(content);
        }
        const contentEl = this.el.querySelector('#right-configure-popup-content');
        contentEl.innerHTML = '';

        const itemHeight = 0.06;
        const itemWidth = 0.56;
        const itemSpacing = 0.02;
        const padding = 0.02;
        const mainLabelFontSize = 0.02;
        const subLabelFontSize = 0.018;

        let cumulativeHeight = 0;

        list.forEach((item, index) => {
            const itemElement = document.createElement('a-entity');
            let itemActualHeight = itemHeight;
            if (item.key === 'chartType') {
                itemActualHeight = itemHeight * 2 + itemSpacing;
            }

            if (item.type === 'toggle') {
                const bg = document.createElement('a-rounded-plane');
                bg.setAttribute('id', `item-bg-${index}`);
                bg.setAttribute('height', itemHeight);
                bg.setAttribute('width', itemWidth);
                bg.setAttribute('radius', '0.01');
                bg.setAttribute('color', itemBgColor);
                bg.setAttribute('opacity', itemBgOpacity);
                bg.setAttribute('position', `0 ${-itemHeight / 2} 0.002`);
                itemElement.appendChild(bg);

                const interactivePlane = document.createElement('a-plane');
                interactivePlane.setAttribute('height', itemHeight);
                interactivePlane.setAttribute('width', itemWidth);
                interactivePlane.setAttribute('position', `${itemWidth / 2} 0 0.001`);
                interactivePlane.setAttribute('opacity', '0');
                if (!item.disabled) {
                    interactivePlane.setAttribute('data-raycastable', '');
                    interactivePlane.addEventListener('click', () => {
                        const newValue = !this.data[item.key];
                        this.el.setAttribute('right-configure-popup', item.key, newValue);
                        this.createSettingsList();
                        if (item.key === 'showExtendedHours') {
                            this._updateChartExtendedHours(newValue);
                        } else if (item.key === 'showEvents') {
                            this._switchShowEvents(newValue);
                            
                            if (window.gtag) gtag('event', `VR_RightPanel_LiveChart_Settings_KeyEvents${newValue ? 'On' : 'Off'}`);
                        }
                    });
                }
                itemElement.appendChild(interactivePlane);

                const mainLabel = document.createElement('a-troika-text');
                mainLabel.setAttribute('value', item.label);
                mainLabel.setAttribute('font-size', mainLabelFontSize);
                mainLabel.setAttribute('color', txtColor);
                mainLabel.setAttribute('anchor', 'left');
                mainLabel.setAttribute('position', `${padding} 0 0.01`)
                itemElement.appendChild(mainLabel);

                if (item.subLabel) {
                    const subLabel = document.createElement('a-troika-text');
                    subLabel.setAttribute('value', item.subLabel);
                    subLabel.setAttribute('font-size', subLabelFontSize);
                    subLabel.setAttribute('color', txtColor);
                    subLabel.setAttribute('anchor', 'left');
                    subLabel.setAttribute('position', `${item.leftMargin || 0} 0 0.01`)
                    subLabel.setAttribute('fill-opacity', '0.5')
                    itemElement.appendChild(subLabel);
                }

                const toggleContainer = document.createElement('a-entity');
                toggleContainer.setAttribute('position', '0.52 0 0.01');

                const toggleBg = document.createElement('a-rounded-plane');
                toggleBg.setAttribute('position', '-0.03 -0.01 0');
                toggleBg.setAttribute('color', isLight ? '#1E1E1E' : '#fff');
                toggleBg.setAttribute('opacity', '0.05');
                toggleBg.setAttribute('height', 0.02);
                toggleBg.setAttribute('width', 0.06);
                toggleBg.setAttribute('radius', 0.006);
                toggleContainer.appendChild(toggleBg);

                const toggleButton = document.createElement('a-rounded-plane');
                const isDisabled = item.disabled || false;
                toggleButton.setAttribute('position', (item.isActive && !isDisabled) ? '0 -0.015 0.005' : '-0.03 -0.015 0.005');
                toggleButton.setAttribute('width', 0.03);
                toggleButton.setAttribute('height', 0.03);
                toggleButton.setAttribute('color', (item.isActive && !isDisabled) ? selectColor : (isLight ? '#737373' : '#4F4F4F'));
                toggleButton.setAttribute('radius', 0.003);
                toggleContainer.appendChild(toggleButton);

                itemElement.appendChild(toggleContainer);
            }

            if (item.key === 'chartType') {

                const mainLabel = document.createElement('a-troika-text');
                mainLabel.setAttribute('value', item.label);
                mainLabel.setAttribute('font-size', mainLabelFontSize);
                mainLabel.setAttribute('color', txtColor);
                mainLabel.setAttribute('anchor', 'left');
                mainLabel.setAttribute('position', `${padding} ${itemHeight / 2} 0.01`)
                itemElement.appendChild(mainLabel);

                const chartTypes = ['Mountain', 'Line', 'Candlestick'];
                const optionWidth = itemWidth / chartTypes.length;
                const optionHeight = 0.044;
                const selectedIndex = Math.max(0, chartTypes.indexOf(this.data.chartType));
                const semitransparentPlane = document.createElement('a-rounded-plane');
                semitransparentPlane.setAttribute('height', optionHeight);
                semitransparentPlane.setAttribute('width', itemWidth);
                semitransparentPlane.setAttribute('radius', '0.01');
                semitransparentPlane.setAttribute('opacity', '0.05');
                semitransparentPlane.setAttribute('color', isLight ? '#000' : '#fff');
                semitransparentPlane.setAttribute('position', `0 -0.04 0.003`);
                itemElement.appendChild(semitransparentPlane);

                const selectPlane = document.createElement('a-rounded-plane');
                selectPlane.setAttribute('height', optionHeight);
                selectPlane.setAttribute('width', optionWidth);
                selectPlane.setAttribute('radius', '0.01');
                selectPlane.setAttribute('color', selectColor);
                selectPlane.setAttribute('position', `${optionWidth * selectedIndex} -0.04 0.004`);
                itemElement.appendChild(selectPlane);

                chartTypes.forEach((val, i) => {
                    const centerX = optionWidth * i + optionWidth / 2;
                    const optionText = document.createElement('a-troika-text');
                    optionText.setAttribute('value', val);
                    optionText.setAttribute('font-size', 0.018);
                    optionText.setAttribute('anchor', 'center');
                    const isSelected = this.data.chartType === val;
                    let optTxtColor;
                    if (isSelected) {
                        optTxtColor = selectedTextColor;
                    } else {
                        optTxtColor = txtColor;
                    }
                    optionText.setAttribute('color', optTxtColor);
                    optionText.setAttribute('position', `${centerX} -0.02 0.01`);
                    itemElement.appendChild(optionText);


                    const interactivePlane = document.createElement('a-plane');
                    interactivePlane.setAttribute('height', optionHeight);
                    interactivePlane.setAttribute('width', optionWidth);
                    interactivePlane.setAttribute('opacity', '0');
                    interactivePlane.setAttribute('data-raycastable', '');
                    interactivePlane.setAttribute('position', `${centerX} -0.02 0.001`);
                    interactivePlane.addEventListener('click', () => {
                        this.el.setAttribute('right-configure-popup', 'chartType', val);
                        this.createSettingsList();
                        this._switchChart(val.toLowerCase());
                        
                        if (window.gtag) gtag('event', `VR_RightPanel_LiveChart_Settings_${chartTypes[i]}`);
                    })
                    itemElement.appendChild(interactivePlane);
                })
            }

            const pos = {
                x: -itemWidth / 2,
                y: -cumulativeHeight - itemActualHeight / 2 - padding
            }
            itemElement.setAttribute('position', `${pos.x} ${pos.y} 0`);
            contentEl.appendChild(itemElement);

            cumulativeHeight += itemActualHeight + itemSpacing;
        })
    },

    _switchChart: function (type) {
        try {
            const rightPanel = document.getElementById("stock-wrapper");
            if (!rightPanel) return;

            let stockChart = rightPanel.querySelector('#stock-chart');
            if (!stockChart) {
                stockChart = document.createElement('a-entity');
                stockChart.setAttribute('id', 'stock-chart');
                rightPanel.appendChild(stockChart);
            }

            const currentPosition = stockChart.getAttribute('position');
            const currentScale = stockChart.getAttribute('scale');

            let currentDataInterval
            let currentShowEventsStatus
            let currentShowExtendedHoursStatus
            const existingUniversal = stockChart.getAttribute('tradingview-universal-chart');
            console.log('update3pop2', existingUniversal)
            console.log('update3pop3', existingUniversal ? existingUniversal.dataInterval : 'no existingUniversal')

            let currentWidth = null;
            let currentHeight = null;
            let currentChartPosition = null;
            let currentChartScale = null;
            if (stockChart.dataset && stockChart.dataset.chartWidth != null) {
                currentWidth = Number(stockChart.dataset.chartWidth);
                if (Number.isNaN(currentWidth)) currentWidth = null;
            }
            if (stockChart.dataset && stockChart.dataset.chartHeight != null) {
                currentHeight = Number(stockChart.dataset.chartHeight);
                if (Number.isNaN(currentHeight)) currentHeight = null;
            }
            if (stockChart.dataset && stockChart.dataset.chartComponentPosition != null) {
                currentChartPosition = stockChart.dataset.chartComponentPosition;
            }
            if (stockChart.dataset && stockChart.dataset.chartComponentScale != null) {
                currentChartScale = stockChart.dataset.chartComponentScale;
            }

            if (existingUniversal) {
                if (existingUniversal.width != null) {
                    currentWidth = existingUniversal.width;
                    if (!stockChart.dataset) stockChart.dataset = {};
                    stockChart.dataset.chartWidth = existingUniversal.width;
                }
                if (existingUniversal.height != null) {
                    currentHeight = existingUniversal.height;
                    if (!stockChart.dataset) stockChart.dataset = {};
                    stockChart.dataset.chartHeight = existingUniversal.height;
                }
                if (existingUniversal.position != null) {
                    currentChartPosition = existingUniversal.position;
                    if (!stockChart.dataset) stockChart.dataset = {};
                    stockChart.dataset.chartComponentPosition = existingUniversal.position;
                }
                if (existingUniversal.scale != null) {
                    currentChartScale = existingUniversal.scale;
                    if (!stockChart.dataset) stockChart.dataset = {};
                    stockChart.dataset.chartComponentScale = existingUniversal.scale;
                }
                if (existingUniversal.dataInterval) {
                    currentDataInterval = existingUniversal.dataInterval
                }
                if (Object.prototype.hasOwnProperty.call(existingUniversal, 'showEvents')) {
                    currentShowEventsStatus = existingUniversal.showEvents
                }
                if (Object.prototype.hasOwnProperty.call(existingUniversal, 'showExtendedHours')) {
                    currentShowExtendedHoursStatus = existingUniversal.showExtendedHours;
                }
            }

            const chartComponent = stockChart.components && stockChart.components['tradingview-universal-chart'];
            if (chartComponent && chartComponent.data) {
                if (currentWidth == null && chartComponent.data.width != null) {
                    currentWidth = chartComponent.data.width;
                    if (!stockChart.dataset) stockChart.dataset = {};
                    stockChart.dataset.chartWidth = currentWidth;
                }
                if (currentHeight == null && chartComponent.data.height != null) {
                    currentHeight = chartComponent.data.height;
                    if (!stockChart.dataset) stockChart.dataset = {};
                    stockChart.dataset.chartHeight = currentHeight;
                }
                if (currentChartPosition == null && chartComponent.data.position != null) {
                    currentChartPosition = chartComponent.data.position;
                    if (!stockChart.dataset) stockChart.dataset = {};
                    stockChart.dataset.chartComponentPosition = currentChartPosition;
                }
                if (currentChartScale == null && chartComponent.data.scale != null) {
                    currentChartScale = chartComponent.data.scale;
                    if (!stockChart.dataset) stockChart.dataset = {};
                    stockChart.dataset.chartComponentScale = currentChartScale;
                }
                if (!currentDataInterval && chartComponent.data.dataInterval) {
                    currentDataInterval = chartComponent.data.dataInterval;
                }
                if (currentShowEventsStatus === undefined && Object.prototype.hasOwnProperty.call(chartComponent.data, 'showEvents')) {
                    currentShowEventsStatus = chartComponent.data.showEvents;
                }
                if (currentShowExtendedHoursStatus === undefined && Object.prototype.hasOwnProperty.call(chartComponent.data, 'showExtendedHours')) {
                    currentShowExtendedHoursStatus = chartComponent.data.showExtendedHours;
                }
            }

            if (stockChart.hasAttribute('tradingview-universal-chart')) stockChart.removeAttribute('tradingview-universal-chart');
            if (stockChart.hasAttribute('tradingview-mountain-chart')) stockChart.removeAttribute('tradingview-mountain-chart');
            if (stockChart.hasAttribute('tradingview-line-chart')) stockChart.removeAttribute('tradingview-line-chart');
            if (stockChart.hasAttribute('tradingview-candlestick-chart')) stockChart.removeAttribute('tradingview-candlestick-chart');
            if (stockChart.hasAttribute('stock-candlestick-chart')) stockChart.removeAttribute('stock-candlestick-chart');

            console.log('update3pop1', getCacheItem("data-interval"))

            const dataInterval = currentDataInterval ||
                (typeof getCacheItem === "function" ? getCacheItem("data-interval") : null) ||
                '1y';
            const resolvedShowExtendedHours = currentShowExtendedHoursStatus !== undefined
                ? currentShowExtendedHoursStatus
                : this.data.showExtendedHours;
            const resolvedShowEvents = currentShowEventsStatus !== undefined
                ? currentShowEventsStatus
                : this.data.showEvents;
            const currentStock =
                typeof getCacheItem === "function"
                    ? getCacheItem("last-opened-stock") || {
                        ticker: "SPY",
                        tickerSummary: {
                            name: "SPDR S&P 500 ETF Trust",
                            primary_exchange: "NYSE",
                        },
                    }
                    : { ticker: "SPY" };

            if (type === "mountain") {
                const mountainAttrs = {
                    stockData: JSON.stringify(currentStock),
                    dataInterval: dataInterval,
                    type: 'mountain',
                    showExtendedHours: resolvedShowExtendedHours,
                    showEvents: resolvedShowEvents,
                };
                if (currentWidth != null && !Number.isNaN(currentWidth)) mountainAttrs.width = currentWidth;
                if (currentHeight != null && !Number.isNaN(currentHeight)) mountainAttrs.height = currentHeight;
                if (currentChartPosition != null) mountainAttrs.position = currentChartPosition;
                if (currentChartScale != null) mountainAttrs.scale = currentChartScale;
                stockChart.setAttribute("tradingview-universal-chart", mountainAttrs);
                if (!stockChart.dataset) stockChart.dataset = {};
                stockChart.dataset.chartType = 'mountain';
                if (currentWidth != null) stockChart.dataset.chartWidth = currentWidth;
                if (currentHeight != null) stockChart.dataset.chartHeight = currentHeight;
                if (currentChartPosition != null) stockChart.dataset.chartComponentPosition = currentChartPosition;
                if (currentChartScale != null) stockChart.dataset.chartComponentScale = currentChartScale;
                if (typeof setCacheItem === 'function') {
                    try { setCacheItem('chart-type', 'mountain', 1440); } catch (e) { }
                }
            } else if (type === "line") {
                const lineAttrs = {
                    stockData: JSON.stringify(currentStock),
                    dataInterval: dataInterval,
                    type: 'line',
                    showExtendedHours: resolvedShowExtendedHours,
                    showEvents: resolvedShowEvents,
                };
                if (currentWidth != null && !Number.isNaN(currentWidth)) lineAttrs.width = currentWidth;
                if (currentHeight != null && !Number.isNaN(currentHeight)) lineAttrs.height = currentHeight;
                if (currentChartPosition != null) lineAttrs.position = currentChartPosition;
                if (currentChartScale != null) lineAttrs.scale = currentChartScale;
                stockChart.setAttribute("tradingview-universal-chart", lineAttrs);
                if (!stockChart.dataset) stockChart.dataset = {};
                stockChart.dataset.chartType = 'line';
                if (currentWidth != null) stockChart.dataset.chartWidth = currentWidth;
                if (currentHeight != null) stockChart.dataset.chartHeight = currentHeight;
                if (currentChartPosition != null) stockChart.dataset.chartComponentPosition = currentChartPosition;
                if (currentChartScale != null) stockChart.dataset.chartComponentScale = currentChartScale;
                if (typeof setCacheItem === 'function') {
                    try { setCacheItem('chart-type', 'line', 1440); } catch (e) { }
                }
            } else if (type === "candlestick") {
                const candleAttrs = {
                    stockData: JSON.stringify(currentStock),
                    dataInterval: dataInterval,
                    type: 'candlestick',
                    showExtendedHours: resolvedShowExtendedHours,
                    showEvents: resolvedShowEvents,
                };
                if (currentWidth != null && !Number.isNaN(currentWidth)) candleAttrs.width = currentWidth;
                if (currentHeight != null && !Number.isNaN(currentHeight)) candleAttrs.height = currentHeight;
                if (currentChartPosition != null) candleAttrs.position = currentChartPosition;
                if (currentChartScale != null) candleAttrs.scale = currentChartScale;
                stockChart.setAttribute("tradingview-universal-chart", candleAttrs);
                if (!stockChart.dataset) stockChart.dataset = {};
                stockChart.dataset.chartType = 'candlestick';
                if (currentWidth != null) stockChart.dataset.chartWidth = currentWidth;
                if (currentHeight != null) stockChart.dataset.chartHeight = currentHeight;
                if (currentChartPosition != null) stockChart.dataset.chartComponentPosition = currentChartPosition;
                if (currentChartScale != null) stockChart.dataset.chartComponentScale = currentChartScale;
                if (typeof setCacheItem === 'function') {
                    try { setCacheItem('chart-type', 'candlestick', 1440); } catch (e) { }
                }
            }

            if (currentPosition) stockChart.setAttribute('position', currentPosition);
            if (currentScale) stockChart.setAttribute('scale', currentScale);

            if (typeof window.updateRightAverageVolumeGaugeFromStock === 'function') {
                window.updateRightAverageVolumeGaugeFromStock(currentStock);
            }

            const popupStockChart = document.getElementById("popup-stock-chart");
            if (popupStockChart && popupStockChart.hasAttribute('tradingview-universal-chart')) {
                const popupComponent = popupStockChart.components['tradingview-universal-chart'];
                if (popupComponent && popupComponent.data) {
                    const popupCurrent = popupStockChart.getAttribute('tradingview-universal-chart') || {};


                    const popupStockData = popupComponent.data.stockData;
                    const popupDataInterval = popupComponent.data.dataInterval || popupCurrent.dataInterval || '1y';
                    const popupWidth = popupComponent.data.width || popupCurrent.width || 500;
                    const popupHeight = popupComponent.data.height || popupCurrent.height || 480;
                    const popupStartDate = popupComponent.data.startDate || popupCurrent.startDate || '';
                    const popupEndDate = popupComponent.data.endDate || popupCurrent.endDate || '';
                    const popupShowExtendedHours = this.data.showExtendedHours;
                    const popupShowEvents = this.data.showEvents;


                    const popupChartConfig = {
                        stockData: popupStockData,
                        dataInterval: popupDataInterval,
                        width: popupWidth,
                        height: popupHeight,
                        type: type,
                        showExtendedHours: popupShowExtendedHours,
                        showEvents: popupShowEvents
                    };

                    if (popupStartDate) popupChartConfig.startDate = popupStartDate;
                    if (popupEndDate) popupChartConfig.endDate = popupEndDate;

                    popupStockChart.setAttribute('tradingview-universal-chart', popupChartConfig);
                    console.log('[right-configure-popup] Updated popup chart type to:', type);
                }
            }

            this.el.sceneEl.emit('chart-settings-changed', {
                type: 'chartType',
                value: type
            });

        } catch (e) {
            console.error("[right-configure-popup] switch chart error", e.message);
        }
    },

    _switchShowEvents: function (showEvents) {
        console.log('_switchShowEvents', showEvents)

        const rightPanel = document.getElementById("stock-wrapper");
        if (!rightPanel) return;
        let stockChart = rightPanel.querySelector('#stock-chart');
        if (!stockChart) return;

        stockChart.setAttribute("tradingview-universal-chart", 'showEvents', showEvents);

        const popupStockChart = document.getElementById("popup-stock-chart");
        if (popupStockChart) {
            popupStockChart.setAttribute("tradingview-universal-chart", 'showEvents', showEvents);
        }
        this.el.sceneEl.emit('chart-settings-changed', {
            type: 'showEvents',
            value: showEvents
        });
    },

    setupDataIntervalListener: function () {
        this._onDataIntervalChanged = (e) => {
            if (!e || !e.detail) return;
            const interval = this._normalizeDataInterval(e.detail.interval);
            this.currentDataInterval = interval;
            this.createSettingsList();
        };
        this.el.sceneEl.addEventListener('data-interval-right-panel', this._onDataIntervalChanged);

        this.currentDataInterval = this._resolveCurrentDataInterval();
    },

    _normalizeDataInterval: function (interval) {
        if (typeof interval !== 'string') return '1y';
        return interval.trim().toLowerCase();
    },

    _resolveCurrentDataInterval: function () {
        const rightPanel = document.getElementById('stock-wrapper');
        const stockChart = rightPanel ? rightPanel.querySelector('#stock-chart') : null;

        if (stockChart) {
            const universalAttr = stockChart.getAttribute('tradingview-universal-chart');
            if (universalAttr && universalAttr.dataInterval) {
                return this._normalizeDataInterval(universalAttr.dataInterval);
            }

            const chartComponent = stockChart.components && stockChart.components['tradingview-universal-chart'];
            if (chartComponent && chartComponent.data && chartComponent.data.dataInterval) {
                return this._normalizeDataInterval(chartComponent.data.dataInterval);
            }
        }

        const cachedInterval = typeof getCacheItem === 'function' ? getCacheItem('data-interval') : null;
        return this._normalizeDataInterval(cachedInterval);
    },

    _updateChartExtendedHours: function (showExtendedHours) {
        const rightPanel = document.getElementById("stock-wrapper");
        if (!rightPanel) return;
        const stockChart = rightPanel.querySelector('#stock-chart');
        if (!stockChart) return;

        stockChart.setAttribute("tradingview-universal-chart", 'showExtendedHours', showExtendedHours);

        const popupStockChart = document.getElementById("popup-stock-chart");
        if (popupStockChart) {
            popupStockChart.setAttribute("tradingview-universal-chart", 'showExtendedHours', showExtendedHours);
        }
        this.el.sceneEl.emit('chart-settings-changed', {
            type: 'showExtendedHours',
            value: showExtendedHours
        });
    },

    update: function (oldData) {
        this._saveSettings();
    },
});
